import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '../../../styles';
import { Icon } from '../../../icons';

const StyledIcon = styled(Icon)`
  width: ${props => props.breakpoint !== 'phone' ? 15.5 : 11.666666666666667}rem;
  height: ${props => props.breakpoint !== 'phone' ? 3.3125 : 2.5}rem;
  color: ${props =>
    props.theme === 'light' ? styles.color.WHITE : props.theme === 'footer' ? styles.color.CHARCOAL : styles.color.BLACK};
`;

const Logo = props => {
  const { breakpoint, className, theme } = props;
  return (
    <StyledIcon
      breakpoint={breakpoint}
      className={className}
      theme={theme}
      icon="#spaceapegames-logo"
    />
  );
};

Logo.propTypes = {
breakpoint: PropTypes.string.isRequired,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark', 'footer']),
};

Logo.defaultProps = {
  theme: 'light',
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(Logo);



// WEBPACK FOOTER //
// ./src/modules/core/components/Logo.js